import CodiceFiscale from "codice-fiscale-js";
import { getUserCards } from "../service/card.service";
import cardModel from "../static/card-model";
import { getCatalogs } from "../service/catalog.service";


export type responseCardSelected = {
    groupCode: string;
    storeCode: string;
    card: string;
    customerName: string;
    points: number;
    groupName: string;
    mainStoreName: string
}

type Catalog = {
    catalogId: number;
    catalogName: string;
    points: number;
    validFromDate: string;
    validToDate: string;
    bookableUntilDate: string;
};

export function goTo( path:string) {
    window.location.pathname = path;
};

export function getSeverity(inventoryStatus: string) {
    switch (inventoryStatus) {
        case 'INSTOCK':
            return 'success';

        case 'PRENOTATO':
            return 'warning';

        case 'OUTOFSTOCK':
            return 'danger';

        default:
            return null;
    }
};

export function isJsonParsable(str: string | null) {
    try {
        if(str === null) {
            return false;
        } else {
            JSON.parse(str);
        }
    } catch (e) {
        return false;
    }
    return true;
}

export function checkCardIsSelected() {
    if(!localStorage.getItem("selectedCard")){
        return false;
    }
    // else if(localStorage.getItem("selectedCard") !== ('null' && 'undefined' && '')){
    else if(localStorage.getItem("selectedCard") !== ('null')){
        return true;
    } else {
        return false;
    }
}

export async function returnCardInfo() :Promise<responseCardSelected> {

        const cardData: cardModel = await getUserCards();
        const cardSelected = localStorage.getItem("selectedCard");
        let response: responseCardSelected;
        const card = cardData.cards.filter( x => x.cardNumber === cardSelected)[0];
        response = {
            groupCode: card.groupId.toString(),
            storeCode: card.mainStoreCode,
            card: card.cardNumber,
            customerName: card.customerName,
            points: card.points,
            groupName: card.groupName,
            mainStoreName: card.mainStoreName
        };
        return response;
}

export async function returnCatalogId() :Promise<string>{
    if(localStorage.getItem("selectedCatalog") !== null){
        const catalogId: string = localStorage.getItem("selectedCatalog") || '';
        return catalogId ? catalogId : '';
    } else {
        if(checkCardIsSelected()){
            await returnCardInfo().then( async card => {
                await getCatalogs(card.groupCode, card.storeCode, card.card).then( async catalogs => {
                    if(catalogs?.length > 0){
                        await setSelectedCatalog(catalogs[0].catalogId);
                        return catalogs[0].catalogId.toString();
                    } else { // no card linked
                        
                        // exitFromApplication(); //qui chiude applicazione quando non trova catalogo
                        return '';
                      }
                })
            });
          } else {
            await getUserCards().then( async (cardData: cardModel) => {
              if(cardData?.cards?.length > 0){
                const card = cardData.cards[0].cardNumber;
                const groupCode = cardData.cards[0].groupId;
                const storeCode = cardData.cards[0].mainStoreCode;
                
                await getCatalogs(groupCode.toString(), storeCode, card).then( async catalogs => {
                    if(catalogs?.length > 0){
                      await setSelectedCatalog(catalogs[0].catalogId);
                      return catalogs[0].catalogId.toString();
                    } else { // no card linked
                        exitFromApplication();
                        return ''
                      }
                  })
               } else { // no card linked
                 exitFromApplication();
                 return ''
               }
              
            })
          }
    }
    return '';
}

export async function getCatalogLength(): Promise<number> {
    if (checkCardIsSelected()) {
        return await returnCardInfo().then(async card => {
            return await getCatalogs(card.groupCode, card.storeCode, card.card).then(catalogs => catalogs?.length || 0);
        });
    } else {
        return await getUserCards().then(async (cardData: cardModel) => {
            if (cardData?.cards?.length > 0) {
                const card = cardData.cards[0].cardNumber;
                const groupCode = cardData.cards[0].groupId;
                const storeCode = cardData.cards[0].mainStoreCode;

                return await getCatalogs(groupCode.toString(), storeCode, card).then(catalogs => catalogs?.length || 0);
            }
            return 0; // Nessuna carta o catalogo trovato
        });
    }
}



export async function fetchCatalogs(groupCode: string, storeCode: string, card: string) {
    try {
        const catalogs = await getCatalogs(groupCode, storeCode, card);
        console.log('Cataloghi recuperati:', catalogs);
        return catalogs;
    } catch (error) {
        console.error('Errore durante il recupero dei cataloghi:', error);
        return [];
    }
}

// export async function getOldestAndNewestCatalog(groupCode: string, storeCode: string, card: string) {
//     const catalogs = await fetchCatalogs(groupCode, storeCode, card);

//     if (catalogs.length === 0) {
//         console.warn('Nessun catalogo trovato.');
//         return { oldestCatalog: null, newestCatalog: null };
//     }

//     const sortedCatalogs = catalogs.sort((a, b) =>
//         new Date(a.bookableUntilDate).getTime() - new Date(b.bookableUntilDate).getTime()
//     );

//     const oldestCatalog = sortedCatalogs[0];
//     const newestCatalog = sortedCatalogs[sortedCatalogs.length - 1];

//     console.log('Catalogo più vecchio:', oldestCatalog);
//     console.log('Catalogo più recente:', newestCatalog);

//     return { oldestCatalog, newestCatalog };
// }


// export async function getCatalogsByBookableDate(): Promise<{ oldestCatalogId: number, newestCatalogId: number }> {
//     const catalogId = localStorage.getItem('selectedCatalog');
//     console.log('Valore di selectedCatalog in localStorage:', catalogId);

//     const rawCatalogs = localStorage.getItem('catalogs') || '[]';
//     const catalogs: Catalog[] = JSON.parse(rawCatalogs);

//     if (catalogs.length === 0) {
//         console.error('Nessun catalogo disponibile.');
//         return { oldestCatalogId: -1, newestCatalogId: -1 };
//     }

//     // Ordina i cataloghi per `bookableUntilDate` in ordine crescente
//     catalogs.sort((a, b) => {
//         const dateA = new Date(a.bookableUntilDate).getTime();
//         const dateB = new Date(b.bookableUntilDate).getTime();
//         return dateA - dateB; // Ordine crescente
//     });

//     const oldestCatalogId = catalogs[0]?.catalogId || -1; // Primo catalogo (data più vicina)
//     const newestCatalogId = catalogs[catalogs.length - 1]?.catalogId || -1; // Ultimo catalogo (data più lontana)

//     console.log('Catalogo più vecchio:', catalogs[0]);
//     console.log('Catalogo più nuovo:', catalogs[catalogs.length - 1]);

//     return { oldestCatalogId, newestCatalogId };
// }

// export async function getMostRecentCatalogId(): Promise<string> {
//     const catalogs: Catalog[] = JSON.parse(localStorage.getItem('catalogs') || '[]');

//     if (catalogs.length === 0) {
//         console.error('Nessun catalogo disponibile nel localStorage.');
//         return '';
//     }

//     const mostRecentCatalog = catalogs.reduce((latest: Catalog, current: Catalog) => {
//         const latestToDate = new Date(latest.validToDate);
//         const currentToDate = new Date(current.validToDate);
//         return currentToDate > latestToDate ? current : latest;
//     });

//     return mostRecentCatalog.catalogId;
// }

// export async function getOldestCatalogId(): Promise<string> {
//     const rawCatalogs = localStorage.getItem('catalogs') || '[]';
//     console.log('Raw Catalogs:', rawCatalogs);
//     const catalogs: Catalog[] = JSON.parse(rawCatalogs);

//     if (catalogs.length === 0) {
//         console.error('Nessun catalogo disponibile nel localStorage.');
//         return '';
//     }
    
//     // Trova il catalogo con la data più vecchia
//     const oldestCatalog = catalogs.reduce((oldest: Catalog, current: Catalog) => {
//         console.log('Comparing:', oldest, current);
//         const oldestToDate = new Date(oldest.validToDate);
//         const currentToDate = new Date(current.validToDate);
//         return currentToDate < oldestToDate ? current : oldest;
//     });

//     console.log('Oldest Catalog:', oldestCatalog);
//     return oldestCatalog.catalogId;
// }


export function setSelectedCard(cardSelected: string) {
    localStorage.setItem("selectedCard", cardSelected); 
}

export function setSelectedCatalog(catalogSelected: string) {
    localStorage.setItem("selectedCatalog", catalogSelected); 
}

export function removeLocalStorageAfterChangeCard() {
        localStorage.removeItem("services");
        localStorage.removeItem("allCustomerInfo");
        localStorage.removeItem("pharmacyInfo");
        localStorage.removeItem("catalogs");
        localStorage.removeItem("points");
        localStorage.removeItem("rewards");
        localStorage.removeItem("GET_ALL_CUSTOMER_TIME");
        localStorage.removeItem("GET_REWARDS_TIME");
        localStorage.removeItem("GET_SERVICES_TIME");
        localStorage.removeItem("GET_CATALOG_TIME");
        localStorage.removeItem("GET_PHARMAINFO_TIME");
        localStorage.removeItem("GET_PROFILE_TIME");
        localStorage.removeItem("GET_POINTS_TIME");
        localStorage.removeItem("selectedCatalog");
        localStorage.removeItem("getPrivacyProfile");
        localStorage.removeItem("getPrivacyInfo");
        localStorage.removeItem("GET_PRIVACY_INFO");
        localStorage.removeItem("GET_PRIVACY_PROFILE");
}

export function  exitFromApplication () {
    clearLocalStorage();
    goTo('/login');
}

export function clearLocalStorage() {
    let timestamp = localStorage.getItem('REQUEST_INSTALL_TIME');
    let pharmacyList = localStorage.getItem('pharmaList');
    let pharmacyListTime = localStorage.getItem('GET_PHARMA_LIST_TIME');
    let themeSelected = localStorage.getItem('theme')
    
    localStorage.clear();

    if(themeSelected){
        localStorage.setItem('theme', themeSelected )
    }
    if(timestamp) {
        localStorage.setItem('REQUEST_INSTALL_TIME',timestamp);
    }
    if(pharmacyList) {
        localStorage.setItem('pharmaList',pharmacyList);
        localStorage.setItem('GET_PHARMA_LIST_TIME',pharmacyListTime || '0');
    }
}

// Consente di eseguire un redirect al menù nel caso siano necessarie delle operazioni
// nel menù
export function redirectOnMenu(): void {
  localStorage.setItem('necessaryActionMenu', 'true');
  goTo('/menu');
}


// Rappresenta il tipo di valore che verrà passato alla funzione checkValidationRequiredString
export enum Enum_ValidationString {
    Any = 1,
    NationalIdNumber = 2,
    NumberCode = 3,
    Email = 4,
    Password = 5,
    Username = 6
} 

// Controlla la validità di una stringa che non deve essere vuota in base al tipo di valore
// (numero di telefono, email, etc...)
// compareValue indica la stringa con cui confrontare il value
export function checkValidationRequiredString(value: string, typeValue: Enum_ValidationString, compareValue?: string): boolean {

    let check: boolean;
    value = value ? value : '';  // per rimuovere eventuali null o undefined

    switch (typeValue) {

        // Se la stringa non è collegata a nessun tipo di valore, eseguo solo il controllo dell' obbligatorietà
        case Enum_ValidationString.Any :
            check = value.length > 0;
            break;

        // Controllo sul codice fiscale
        case Enum_ValidationString.NationalIdNumber :
            check = CodiceFiscale.check(value);
            break;

        // Controllo sul numero di telefono
        case Enum_ValidationString.NumberCode :
            let regexExpNumberCode: RegExp = new RegExp('[0-9\\.\\-\\s\\/]{9,}$');
            check = regexExpNumberCode.test(value) && value.length > 0;
            break;

        // Controllo sull' email
        case Enum_ValidationString.Email :
            let regexExpEmail: RegExp = new RegExp('^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$');
            check = regexExpEmail.test(value) && value.length > 0;
            break;

        case Enum_ValidationString.Password :
            let regexExpPassword: RegExp = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$');
            check = regexExpPassword.test(value) && value.length > 0;
            break;

        case Enum_ValidationString.Username :
            let regexExpUsername: RegExp = new RegExp('^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$');
            check = ! regexExpUsername.test(value) && value.length > 0;
            break;

        default:
            check = value.length > 0;
            break;
    }  // fine switch

    if(compareValue !== null && compareValue !== undefined) {
        check = check && (value === compareValue)
    }
    return check;
}

// Converte una stringa in formato capitalize, rendendo la prima lettera maiuscola e le altre minuscole
export function capitalizeFormat(word: string): string {
    if (!word) return word;
    return word[0].toUpperCase() + word.substring(1).toLowerCase();
}

// Controllo per i form in cui c'è Nome e Cognome
// Controlla solo che i caratteri del nome sommati ai caratteri del cognome siano in totale, massimo 99
export function checkNumCharactersNameAndSurname(name: string, surname: string): boolean {
    let numCharName: number = name ? name.length : 0;
    let numCharSurname: number = surname ? surname.length : 0;
    return ((numCharName + numCharSurname) <= 99);
}

// Consente di pulire la stringa dagli spazi iniziali, dai doppi spazi (mettendone uno)
// ed opzionalmente lo spazio finale (in modo che se viene richiamata all' onchange di un input è possibile immettere uno spazio)
export function clearStringData(data: string, allowTrimEnd: boolean): string {
    if(data) {
        data = data.trimStart().replaceAll('  ',' ');
        if(allowTrimEnd) {
            data = data.trimEnd();
        }
        return data;
    }
    else {
        return data;
    }
}

export function convertTicks(ticks: number){
    let epochTicks = 621355968000000000,    // the number of .net ticks at the unix epoch
        ticksPerMillisecond = 10000,        // there are 10000 .net ticks per millisecond
        jsTicks = 0,                        // ticks in javascript environment
        jsDate,                             // Date in javascript environment
        input = ticks;
    
        jsTicks = (input - epochTicks) / ticksPerMillisecond;
    
        jsDate = new Date(jsTicks); // N.B. Js applies local timezone in automatic
  
        let result = ("0" + jsDate.getDate()).slice(-2) + "/" + ("0"+(jsDate.getMonth()+1)).slice(-2) + "/" +
        jsDate.getFullYear() + " " + ("0" + jsDate.getHours()).slice(-2) + ":" + ("0" + jsDate.getMinutes()).slice(-2);
    
        return result;
    }

export function downloadFileFromBlob(fileBlob: Blob, nomeFile: string): void {
    try {
        let fileURL = window.URL.createObjectURL(fileBlob);

        const link = document.createElement("a");
        link.href = fileURL;
        link.download = nomeFile;
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileURL);
    }
    catch {
        console.log('Download informativa privacy fallito');
    }
}

export function resetZoomLevel(): void {
    /* https://stackoverflow.com/questions/22639296/force-mobile-browser-zoom-out-with-javascript */
    
    document.querySelector('meta[name="viewport"]')!.setAttribute('content', "width=device-width, initial-scale=0.99, maximum-scale=1, user-scalable=no");

    setTimeout(()=> {
        document.querySelector('meta[name="viewport"]')!.setAttribute('content', "width=device-width, initial-scale=1");
    },100)

}


export type Days = {
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
  };
  
  const getDays = (day: string) => {
    switch (day) {
      case "monday":
        return "Lunedì";
      case "tuesday":
        return "Martedì";
      case "wednesday":
        return "Mercoledì";
      case "thursday":
        return "Giovedì";
      case "friday":
        return "Venerdì";
      case "saturday":
        return "Sabato";
      case "sunday":
        return "Domenica";
      default:
        return "";
    }
  };
  
  export function getPromoDays(days: Days): string {
    let allDays: boolean =
      Object.values(days).filter((x) => x === true).length === 7 ||  Object.values(days).filter((x) => x === true).length === 0
        ? true
        : false;
    if (allDays) {
      // se tutti i giorni sono true o false non visualizzo l'informazione riguardante i giorni
      return "";
    } else {
      if (Object.values(days).filter((x) => x === true).length > 0) {
        let message: string = "<span class='label-ogni'>Ogni: </span><span>";
        let listDaysIta: string[] = Object.entries(days)
            .filter(([key,value]) => value === true)
            .map(([key,value]) => getDays(key))
        message += listDaysIta.join(', ') + '</span>'
          
        return message;
      } else {
        return "";
      }
    }
  }

  export function getFormatImageFile(imageName: string): string {

    imageName = imageName ? imageName : '';
    let format: string = '';
    let positionLastPoint: number = imageName.lastIndexOf('.');

    if(positionLastPoint > -1) {
        format = imageName.substring(positionLastPoint + 1);
    }
    
    return format;
  }

  // Funzione utilizzata per sapere se si è online, in quanto il simulatore di chrome se impostato a offline
  // e si richiama un redirect con window.location, navigator.online restituirà true.
  export async function getIsOnline() {

    if(window.location.origin.indexOf('localhost')) {
        if (!window.navigator.onLine) return false

        try {
            const response = await fetch(
              window.location.origin,
              { method: 'HEAD' },
            )
    
            return response.ok
        }
        catch {
            return false;
        }
    }
    else {
        return navigator.onLine;
    }

  }


/**
 * Calcola il codice fiscale italiano
 * @param nome Nome
 * @param cognome Cognome
 * @param giorno Giorno di nascita
 * @param mese Mese di nascita (1-12)
 * @param anno Anno di nascita (es. 1990)
 * @param sesso "M" o "F"
 * @param comune Nome del comune (es. "Roma")
 * @param provincia Sigla della provincia (es. "RM")
 * @returns Codice fiscale o stringa vuota in caso di errore
 */
export function calcolaCodiceFiscale(
  nome: string,
  cognome: string,
  giorno: number,
  mese: number,
  anno: number,
  sesso: "M" | "F",
  comune: string,
  provincia: string
): string {
  try {
    const cf = new CodiceFiscale({
      name: nome,
      surname: cognome,
      gender: sesso,
      day: giorno,
      month: mese,
      year: anno,
      birthplace: comune,
      birthplaceProvincia: provincia,
    });

    return cf.toString(); // ✅ Questo è il modo corretto
  } catch (error) {
    console.error("Errore nel calcolo del codice fiscale:", error);
    return "";
  }
}